import React from "react";
import classNames from "classnames";

// TODO a ref-et szépen ahogy azt kéne, meg kell majd csinálni, csak érteni is kéne hogy mi történik.
const createForm = (SubForm) => {
    return React.forwardRef((props, _ref) => {
        let ref = _ref;
        if (ref instanceof Function) {
            ref = (form) => {
                if (form) {
                    form.refresh = () => {
                        props.reloadForm();
                    };
                    form.refreshBackground = () => {
                        props.reloadForm();
                    };
                }
                _ref(form);
            }
        }
        return <SubForm ref={ref} {...props} />;
    });
}

export default createForm;
